import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbsUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconThumbsUp"><Path fillRule="evenodd" clipRule="evenodd" d="M10.382 2H11.6156C13.4567 2 14.8634 3.64303 14.5798 5.46216L14.1841 8H18.0631C20.4871 8 22.354 10.1387 22.0265 12.5405L21.3446 17.5405C21.0744 19.5224 19.3816 21 17.3813 21H2V10H6.38197L10.382 2ZM6 12H4V19H6V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThumbsUp;
